import { defineComponent as _defineComponent } from 'vue'
import { ValidationObserver } from 'vee-validate'
import { computed, nextTick, ref } from 'vue'




import { defineComponent as __MACROS_defineComponent } from "vue";
const __default__ = __MACROS_defineComponent({
  inheritAttrs: false,
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AppForm',
  props: {
  submit: { type: Function, default: () => void 0 },
  resetAfterSubmit: { type: Boolean, default: false }
},
  emits: ["reset", "failure"],
  setup(__props, { expose, emit }) {

const props = __props;





const validationObserver = ref<InstanceType<typeof ValidationObserver> | null>(null)

const submitting = ref(false)

async function handleSubmit() {
  submitting.value = true

  const { isValid, errors } = await validationObserver.value!.validateWithInfo()
  if (!isValid) {
    submitting.value = false
    emit('failure', errors)
    return
  }
  try {
    await props.submit()
    if (props.resetAfterSubmit) {
      await handleReset()
    }
  } finally {
    submitting.value = false
  }
}

async function handleReset() {
  emit('reset')
  await nextTick()
  validationObserver.value?.reset()
}

expose({
  handleSubmit,
  handleReset,
  submitting,
  setErrors: (errors: Record<string, string[] | string>) => {
    validationObserver.value?.setErrors(errors)
  },
  errors: computed(() => validationObserver.value?.errors ?? {}),
})

return { __sfc: true,props, emit, validationObserver, submitting, handleSubmit, handleReset, ValidationObserver }
}

})